$(document).ready(function () {
    if ($('.ttgNCECounter').length) {
		var api = "/fileadmin/projects/tourdata/php/loadTourdataNumbers.php";

		$.ajax({
			url: api,
			dataType: 'jsonp',
		}).done(function(data) {

			var json = $.parseJSON(data);
			$(json).each(function(i,val){
				$.each(val,function(k,v){
					$.each(v,function(key,value){

						// 0: Adresse
						// 1: Benutzer
						// 2: Experience
						// 3: Gastro
						// 4: Gebiet
						// 5: GlobalePauschale
						// 6: Leistung
						// 7: OrteInformation
						// 8: Poi
						// 9: Tour
						// 10: Veranstaltung
						// 11: Vermieter

						var adresseAnzahl = v[0].Anzahl;
						$('.ttgNCECounterNumber[data-type="Adresse"]').attr('data-live', adresseAnzahl);

						var benutzerAnzahl = v[1].Anzahl;
						$('.ttgNCECounterNumber[data-type="Benutzer"]').attr('data-live', benutzerAnzahl);

						var experienceAnzahl = v[2].Anzahl;
						$('.ttgNCECounterNumber[data-type="Experience"]').attr('data-live', experienceAnzahl);

						var gastroAnzahl = v[3].Anzahl;
						$('.ttgNCECounterNumber[data-type="Gastro"]').attr('data-live', gastroAnzahl);

						var regionAnzahl = v[4].Anzahl;
						$('.ttgNCECounterNumber[data-type="Gebiet"]').attr('data-live', regionAnzahl);

						var pauschaleAnzahl = v[5].Anzahl;
						$('.ttgNCECounterNumber[data-type="GlobalePauschale"]').attr('data-live', pauschaleAnzahl);

						var leistungAnzahl = v[6].Anzahl;
						$('.ttgNCECounterNumber[data-type="Leistung"]').attr('data-live', leistungAnzahl);

						var orteAnzahl = v[7].Anzahl;
						$('.ttgNCECounterNumber[data-type="OrteInformation"]').attr('data-live', orteAnzahl);

						var poiAnzahl = v[8].Anzahl;
						$('.ttgNCECounterNumber[data-type="Poi"]').attr('data-live', poiAnzahl);

						var tourAnzahl = v[9].Anzahl;
						$('.ttgNCECounterNumber[data-type="Tour"]').attr('data-live', tourAnzahl);

						var veranstaltungAnzahl = v[10].Anzahl;
						$('.ttgNCECounterNumber[data-type="Veranstaltung"]').attr('data-live', veranstaltungAnzahl);

						var vermieterAnzahl = v[11].Anzahl;
						$('.ttgNCECounterNumber[data-type="Vermieter"]').attr('data-live', vermieterAnzahl);

						// console.log(key+" : "+ value.Anzahl);
					});
				});
			});
		}).always(function() {
			$('.ttgNCECounter').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
				if (isInView) {
					setTimeout(function(){
						$('.ttgNCECounterNumber').each(function () {
							var $this = $(this);
							var countTo = '';

							if ($this.attr('data-live')) {
								countTo = $this.attr('data-live');
							} else {
								countTo = $this.attr('data-count');
							}

							$({countNum: $this.text()}).animate({
								countNum: countTo
							},
							{
								//duration: countTo * 10,
								duration: 4000,
								easing: 'linear',
								step: function () {
									$this.text(Math.floor(this.countNum));
								},
								complete: function () {
									$this.text(this.countNum);
								}

							});
						});
					}, 250);
				}
			});
		});

    }
});